import { AppLayoutSettings } from "../../pages/common.styles";

export const iconStyle = {
    color: AppLayoutSettings.AppColors.primaryWidgetColor,
    fontSize: AppLayoutSettings.AppFontSize.extraLargeFontSizePx,
    padding: '0px 16px 4px 0px',
    cursor: 'pointer'
};

export const getComponentRootContainerProperties = (): React.CSSProperties => {
    const CSSProperties: React.CSSProperties = {
        height: '20px',
        flexDirection: 'row',
        display: 'flex'
    };

    return CSSProperties;
};
